import { graphql } from "@apollo/client/react/hoc"
import get from "lodash/get"
import PropTypes from "prop-types"
import RESOURCE_PUBLISHER_QUERY from "./resource-publisher-query"

const withResourcePublisherQuery = graphql(RESOURCE_PUBLISHER_QUERY, {
  options: ({ id }) => ({
    variables: { id }
  }),
  props: ({ data }) => ({
    error: data.error,
    loading: data.loading,
    publisher: get(data, "resource.publisher")
  })
})

const ResourcePublisherQuery = withResourcePublisherQuery(
  ({ children, ...rest }) => children(rest) || null
)

ResourcePublisherQuery.displayName = "ResourcePublisherQuery"

ResourcePublisherQuery.propTypes = {
  id: PropTypes.number.isRequired
}

export default ResourcePublisherQuery
